import { SubscriptionDialogComponent } from '../../your-impact-module/your-impact/subscription-dialog/subscription-dialog.component';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { LanguageService } from '../../services/language.service';
import { RouterUrls } from '../../shared/router-urls';

@Component({
  selector: 'app-vote-complete-dialog',
  templateUrl: './vote-complete-dialog.component.html',
  styleUrls: ['./vote-complete-dialog.component.scss']
})
export class VoteCompleteDialogComponent implements OnInit {

  RouterUrls = RouterUrls;
  projectInfo;
  hasSubs = false;
  alreadyVoted = false;

  constructor(private dialogRef: MatDialogRef<VoteCompleteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private router: Router,
              private dialog: MatDialog,
              private languageService: LanguageService) {
    this.projectInfo = data.project;
    this.hasSubs = data.hasSubs;
  }

  ngOnInit(): void {
  }

  closeDialog(parameter?) {
    this.dialogRef.close();
  }

  gotoImpactPage() {
    this.router.navigate([this.languageService.getCurrentLangWithSlash(), RouterUrls.YourImpact]);
    this.closeDialog();
  }
  openOneTimeDonation() {
    const subscriptiondialogConfig = new MatDialogConfig();
    let oneTimeDonation = true;
    if (!this.hasSubs){
      oneTimeDonation = false;
    }
    subscriptiondialogConfig.width = '953px';
    subscriptiondialogConfig.disableClose = true;
    subscriptiondialogConfig.panelClass = 'subscription-dialog';
    subscriptiondialogConfig.maxWidth = '953px';
    subscriptiondialogConfig.closeOnNavigation = true;
    subscriptiondialogConfig.backdropClass = 'backdropBackground';
    subscriptiondialogConfig.data = {
      oneTimeDonation,
      projectId: this.projectInfo.id
    };
    this.dialog.open(SubscriptionDialogComponent, subscriptiondialogConfig);
    this.closeDialog();
  }
}
